import Flicking from '@egjs/react-flicking'
import React, { useRef, useState } from 'react'
import Slider from '../molecules/Slider'
import MediaItem from '../organisms/MediaItem'

const M11MediaContainer = ({ heading, mediaItems, anchorLinkId }) => {
  const ref = useRef()
  const [currentIndex, setCurrentIndex] = useState(0)

  const handleChange = index => {
    ref.current?.moveTo(index)
  }
  const hasLabels = !mediaItems.some(item => !item.tabLabel)

  return (
    <section className="my-10 overflow-hidden md:my-20" id={anchorLinkId}>
      <div className="container">
        {heading && <div className="mb-5 u-h1">{heading}</div>}

        {mediaItems.length > 1 && !hasLabels && (
          <Slider
            count={mediaItems.length}
            index={currentIndex}
            onChange={handleChange}
          />
        )}
        {mediaItems.length > 1 && hasLabels && (
          <div className="flex items-center w-full mb-8 space-x-8 overflow-x-auto">
            {mediaItems.map((_, i) => (
              <button
                type="button"
                key={i}
                onClick={() => handleChange(i)}
                className={`font-bold text-[15px] border-b-2 transition-all whitespace-nowrap ${
                  i === currentIndex ? 'border-black' : 'border-transparent'
                }`}
              >
                {mediaItems[i].tabLabel}
              </button>
            ))}
          </div>
        )}

        {mediaItems.length > 1 && (
          <div className="w-full">
            <Flicking
              autoInit
              ref={ref}
              onWillChange={e => setCurrentIndex(e.index)}
            >
              {mediaItems.map((mediaItem, index) => (
                <div key={index} className="w-full mr-8 row-type-g sm:mr-0">
                  <div className="col-1-type-g3">
                    <div className="w-full">
                      <MediaItem mediaItem={mediaItem} />
                    </div>
                  </div>
                </div>
              ))}
            </Flicking>
          </div>
        )}
        {mediaItems.length === 1 && (
          <div className="row-type-g">
            <div className="col-1-type-g3">
              <div className="w-full">
                <MediaItem mediaItem={mediaItems[0]} />
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  )
}

export default M11MediaContainer
